import { render, staticRenderFns } from "./ManageUserGroupsModalTable.vue?vue&type=template&id=7264ec0e&scoped=true&"
import script from "./ManageUserGroupsModalTable.vue?vue&type=script&lang=js&"
export * from "./ManageUserGroupsModalTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserGroupsModalTable.vue?vue&type=style&index=0&id=7264ec0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264ec0e",
  null
  
)

export default component.exports